module.exports = __webpack_public_path__ + "assets/src/style/img/svg/marker.svg?cb9c6641207061f349a09301435d058b";